/**
 * Sprachliste als plattformfreie Konstante (0.10) — Web-Init (i18next mit
 * Browser-Detector) und native App (Gerätesprache) teilen sie sich.
 */
export const SUPPORTED_LANGUAGES = ['de', 'it', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
